import React from "react";
import PropTypes from "prop-types";
import HeaderTipshelf from "../HeaderTipshelf";

import styles from "./MainApp.layouts.DesktopLayoutTipshelf.module.scss";
export class DesktopLayoutTipshelf extends React.Component {
  render() {
    const {
      content,
      headerTitle,
      headerOptions,
      headerOptionsIcons,
      goBackFunc,
      headerButtonLabel,
      headerButtonHandler,
      headerButtonState,
      customButtons,
      onHandleMouseDown,
      onHandleClickClean,
      darkMode,
      screenState,
      handleClickTurnScreen,
    } = this.props;

    return (
      <div className={styles["desktop-main-layout-tipshelf-container"]}>
        <div className={styles["right-layout-tipshelf-container"]}>
          <HeaderTipshelf
            title={headerTitle}
            options={headerOptions}
            optionsIcons={headerOptionsIcons}
            goBackFunc={goBackFunc}
            buttonLabel={headerButtonLabel}
            buttonHandler={headerButtonHandler}
            buttonState={headerButtonState}
            content={customButtons}
            onHandleMouseDown={onHandleMouseDown}
            onHandleClickClean={onHandleClickClean}
            darkMode={darkMode}
            screenState={screenState}
            handleClickTurnScreen={handleClickTurnScreen}
          ></HeaderTipshelf>
          {content}
        </div>
      </div>
    );
  }
}

DesktopLayoutTipshelf.propTypes = {
  content: PropTypes.any,
};

export default DesktopLayoutTipshelf;
